import { createRequestInstance } from '..'

const AGREEMENTS_URL = import.meta.env.VITE_AGREEMENTS_URL || ''
const ATK_AGREEMENT_ID = import.meta.env.VITE_ATK_AGREEMENT_ID || ''

const request = createRequestInstance({
  baseURL: AGREEMENTS_URL,
})

export type fetchUserAgreementResponse = {
  agreementId: string
  creationDate: string
  jurisdictionName: string
  localeCode: string
  valid: boolean
  validUntil: string
  versionNumber: number
}

export async function fetchUserAgreement(userId: number) {
  const response = await request.get<fetchUserAgreementResponse>(
    `/agreements/${ATK_AGREEMENT_ID}/signatures/${userId}`,
  )

  const { data } = response

  const { valid } = data

  return {
    valid: valid,
  }
}
